import service from './RestService';
import { RestResponse } from '../types/response/RestResponse';
import { RestErrorResponse } from '../types/response/RestErrorResponse';
import { AuthResponse, LoginFormData } from '../state/auth/types';
import { UserInfo } from '../state/user/types';

const path = '/account';

class AccountService {
  loginExternal = (data: LoginFormData): RestResponse<AuthResponse> =>
    service.get(`${path}/login`, { username: data.email, password: data.password });

  silentLoginExternal = (): RestResponse<AuthResponse> => service.get(`${path}/silent-login`);

  userInfo = (projectId?: number): RestResponse<UserInfo> => service.get(`${path}/user-info${projectId ? `?projectId=${projectId}` : ''}`);

  changeLanguage = (language: string): RestResponse<any> => service.post(`${path}/lang?lang=${language}`);

  checkEmail = (email: string): RestResponse<RestErrorResponse> => service.get(`${path}/check-email/${email}`);
}
export default new AccountService();
